@for (notice of notices; track notice) {
  <div>
    <p-tag
      severity="warning"
      value="{{ notice.notifiedAt }}"></p-tag>
    <p-tag
      severity="success"
      value="{{ getType(notice.notificationType) }}"></p-tag>
    @if (notice.detail) {
      <p-tag
        severity="primary"
        value="{{ notice.detail }}"></p-tag>
    }
  </div>
}
